import { Button } from '@mui/material';

import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/context/Modal.context';
import { useQualityControlTool } from '@/context/Qualitycontrol.context';
import { INCORRECT_MEASUREMENT_DEFECT_TYPE_ID } from '@/helpers/defect-form.ts';
import { useQcMode } from '@/hooks/use-qcMode';
import { CheckPointType } from '@/types/Checkpoint';
import { PRODUCT_TYPES } from '@/types/ProductInfo';

const SIZE_DIMENSION_CHECKPOINT_ID = 5;

interface DefectButtonProps {
  checkPoint: CheckPointType;
  disabled?: boolean;
}

export default function ActionButtons({
  checkPoint,
  disabled,
}: DefectButtonProps) {
  const { t } = useTranslation();

  const { setModalInfo } = useModal();
  const { isViewMode } = useQcMode();
  const { qcData: { product } = {}, defects } = useQualityControlTool();

  const isBagDimCheckpoint =
    checkPoint.id === SIZE_DIMENSION_CHECKPOINT_ID &&
    product?.type?.toLowerCase() === PRODUCT_TYPES.BAG;

  const measurementAssistantFormDisabled =
    defects.some(
      (d) => d.defectType?.id === INCORRECT_MEASUREMENT_DEFECT_TYPE_ID
    ) || isViewMode;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 1,
        width: '100%',
      }}
    >
      {isBagDimCheckpoint && (
        <Button
          data-testid="measureme_assistant_button"
          disabled={measurementAssistantFormDisabled}
          onClick={() => {
            setModalInfo({
              modalType: 'MEASUREMENT_ASSISTANT',
              modalInfo: {
                checkpointName: checkPoint.name,
                checkpointId: checkPoint.id,
              },
            });
          }}
        >
          {`${t('QC_V2.MAIN.MEASUREMENT_ASSISTANT')}`}
        </Button>
      )}
      <Button
        data-testid="defect_button_add"
        disabled={isViewMode || disabled}
        onClick={() => {
          if (checkPoint.id) {
            setModalInfo({
              modalType: 'DEFECT_CREATION',
              modalInfo: {
                checkpointName: checkPoint.name,
                checkpointId: checkPoint.id,
              },
            });
          }
        }}
      >
        {`+${t('QC_V2.MAIN.ADD')}`}
      </Button>
    </Box>
  );
}
